import React, { useEffect, useState } from "react";
import { Scatter } from "react-chartjs-2";
import { Chart as ChartJS, Title, Tooltip, Legend, CategoryScale, LinearScale, PointElement, TimeScale } from "chart.js";
// Import the date adapter
import 'chartjs-adapter-date-fns';

// Register the necessary Chart.js components
ChartJS.register(Title, Tooltip, Legend, CategoryScale, LinearScale, PointElement, TimeScale);

const TaskStatusChart = () => {
    const [chartData, setChartData] = useState(null);

    const apiData = [
        { task_scheduledon: "2024-11-21T00:00:00", STATUS: "OPEN", COUNT: 4 },
        { task_scheduledon: "2024-11-22T00:00:00", STATUS: "OPEN", COUNT: 1 },
        { task_scheduledon: "2024-11-24T00:00:00", STATUS: "OPEN", COUNT: 1 },
        { task_scheduledon: "2024-11-23T00:00:00", STATUS: "BEYOND THE SCOPE", COUNT: 1 },
        { task_scheduledon: "2024-11-20T00:00:00", STATUS: "COMPLETED", COUNT: 1 },
        { task_scheduledon: "2024-11-21T00:00:00", STATUS: "COMPLETED", COUNT: 1 },
        { task_scheduledon: "2024-11-23T00:00:00", STATUS: "COMPLETED", COUNT: 1 },
        { task_scheduledon: "2024-11-25T00:00:00", STATUS: "COMPLETED", COUNT: 2 },
        { task_scheduledon: "2024-11-26T00:00:00", STATUS: "COMPLETED", COUNT: 2 },
        { task_scheduledon: "2024-11-21T00:00:00", STATUS: "CUSTOMER_REJECTION", COUNT: 1 },
        { task_scheduledon: "2024-11-25T00:00:00", STATUS: "ESCALATED", COUNT: 1 },
    ];

    useEffect(() => {
        // Process the API data
        const processChartData = () => {
            const data = apiData.map((item) => {
                const date = new Date(item.task_scheduledon);
                let color;

                // Determine color based on status
                if (item.STATUS === "OPEN") {
                    color = "blue";
                } else if (item.STATUS === "COMPLETED") {
                    color = "green";
                } else {
                    color = "red";
                }

                return {
                    x: date.getTime(), // Use timestamp for better charting
                    y: item.COUNT,
                    backgroundColor: color,
                };
            });

            setChartData(data);
        };

        processChartData();
    }, []);

    const scatterData = {
        datasets: [
            {
                label: "Task Status",
                data: chartData,
                backgroundColor: chartData ? chartData.map((point) => point.backgroundColor) : [],
                pointStyle: "circle",
                pointRadius: 6,
            },
        ],
    };

    const options = {
        plugins: {
            legend: {
                display: true,
            },
        },
        scales: {
            x: {
                type: "time",
                time: {
                    unit: "day",
                    tooltipFormat: "MMM dd, yyyy",
                    displayFormats: {
                        day: "MMM dd",
                    },
                },
                title: {
                    display: true,
                    text: "Date",
                },
            },
            y: {
                title: {
                    display: true,
                    text: "Task Count",
                },
            },
        },
    };

    return (
        <div>
            <h3>Task Status Chart</h3>
            {chartData ? <Scatter data={scatterData} options={options} /> : <p>Loading chart...</p>}
        </div>
    );
};

export default TaskStatusChart;
